import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStores } from 'hooks/useStores';
import Seo from 'components/Seo';
import styles from './articles.module.scss';

const seo = {
  seo_title: 'Статьи — Пак Пакыч',
  seo_description: 'Полезные статьи о строительных материалах',
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('ru');
};

const ArticlesPage = () => {
  const { api } = useStores();
  const [articles, setArticles] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api.content
      .getArticles()
      .then((data) => {
        setArticles(Array.isArray(data) ? data : data?.results ?? []);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [api]);

  return (
    <>
      <Seo seo={seo} />
      <main className={styles.page}>
        <h1 className={styles.title}>Статьи</h1>

        {isLoading && <p className={styles.loading}>Загрузка...</p>}

        {!isLoading && articles?.length === 0 && (
          <p className={styles.empty}>Статей пока нет</p>
        )}

        {!isLoading && articles?.length > 0 && (
          <div className={styles.grid}>
            {articles.map((item) => (
              <article key={item.id} className={styles.card}>
                {item.cover_image && (
                  <img
                    className={styles.cover}
                    src={item.cover_image}
                    alt={item.cover_image_alt || item.title}
                    loading="lazy"
                  />
                )}
                <div className={styles.cardBody}>
                  <h2 className={styles.cardTitle}>
                    <Link
                      className={styles.cardLink}
                      to={`/articles/${item.slug}`}
                    >
                      {item.title}
                    </Link>
                  </h2>
                  {item.published_at && (
                    <p className={styles.date}>{formatDate(item.published_at)}</p>
                  )}
                  {item.short_description && (
                    <p className={styles.description}>{item.short_description}</p>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </main>
    </>
  );
};

export default ArticlesPage;
